import httpClient from '@api/httpClient'
import type { PaginatedResponse } from '@models/pagination'
import type { InvoiceDebt, InvoiceDebtFilters } from '@models/invoiceDebt'
import { invoiceDebtsUrls } from './constants'

const getInvoiceDebts = async (filters?: InvoiceDebtFilters) => {
  const { data } = await httpClient.get<PaginatedResponse<InvoiceDebt>>(
    invoiceDebtsUrls.list(),
    { params: filters },
  )

  return data
}

export default { getInvoiceDebts }
